module.exports = __webpack_public_path__ + "cf3c1497728e94b6ee99e9146c5988e9.png";